import React, { FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import { IMenuTypes } from 'utils/models';

// components
import SideActions from './SideActions';
import Modal from './Modal';
import ModalProductInfo from './modals/ModalProductInfo';
import { SvgDashMenu, SvgProfileMenu, SvgSchedMenu } from './SvgIcons';

import storage from 'utils/storage';
import { SvgEnvelope } from './SvgIconsNew';

const SideBar: FC = () => {
  const [isCollapse, setIsCollapse] = useState<boolean>(true);
  const [openProductInfo, setOpenProductInfo] = useState<boolean>(false);

  const links: IMenuTypes[] = [
    {
      icon: <SvgDashMenu className="w-5 h-5" />,
      label: 'Overview',
      to: '/dashboard'
    },
    {
      icon: <SvgSchedMenu className="w-5 h-5" />,
      label: 'Schedule',
      to: '/schedule'
    },
    {
      icon: <SvgProfileMenu className="w-5 h-5" />,
      label: 'Patients',
      to: '/patient-list'
    },
    {
      icon: <SvgEnvelope className="w-5 h-5" />,
      label: 'Inbox',
      to: '/inbox'
    }
  ];

  useEffect(() => {
    const collapse = storage.getItem('collapse');
    if (collapse) setIsCollapse(JSON.parse(collapse));
  }, []);

  return (
    <>
      <div className="hidden md:block h-[calc(100dvh-7rem)] mt-6">
        <div className={clsx('bg-white h-full relative rounded-r-md', !isCollapse && 'w-50')}>
          <div className="pt-5">
            <SideActions actions={links} isCollapse={true} />
          </div>
        </div>
      </div>

      <Modal
        open={openProductInfo}
        onClose={setOpenProductInfo}
        size="7xl"
        classNameChild="!p-0"
        round="lg"
      >
        <ModalProductInfo showRecentView showSavedProducts />
      </Modal>
    </>
  );
};

export default SideBar;
